export const CHECK_CODE_FAILURE = "[DEVICES] CHECK_CODE_FAILURE";

interface CheckCodeFailureAction {
  type: typeof CHECK_CODE_FAILURE;
  payload: object & { code: string | number };
}

export type RequestsWithCodeActionTypes = CheckCodeFailureAction;
